import { createUrl, restPost } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { getHeaderBidderAdaptersForPublisher } from '~/src/dash/utils/header-bidder-adapters';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';

interface IFetchDemandSourcesMapProps {
  publisherID: string;
  siteIDs?: string; // example: '30, 11, 23'
}

export interface IFilteredDemandSources {
  DemandSourcesMap: Record<string, boolean>;
}

export async function fetchDemandSourcesMap(
  publisherID: string,
  onlyActive = false,
  query?: IFetchDemandSourcesMapProps,
): Promise<IFilteredDemandSources> {
  let reqUrl = `${createUrl('/filtered_demand_sources', publisherID, 'v2')}`;
  if (onlyActive) {
    reqUrl += '&active=' + encodeURIComponent(String(EBool.EBool_TRUE));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = await restPost<any>(reqUrl, query || {});
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return response.parsedBody;
}

export const generateDemandSourcesOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const publisherID = session.publisher.ID;
  return fetchDemandSourcesMap(publisherID, false, { publisherID, siteIDs: '' })
    .then(({ DemandSourcesMap }) => {
      const demandSourceAdapters = [
        ...getHeaderBidderAdaptersForPublisher(
          '',
          false,
          session.publisher,
          hasRoleSuperUser(user.user),
        ),
      ];
      return demandSourceAdapters
        .filter((adapter) => DemandSourcesMap[adapter.key])
        .map(
          (adapter) =>
            ({
              id: adapter.key,
              label: adapter.text,
            }) as ISelectOption,
        );
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};
